module.exports = "pegasus_template/assets/themelp1/travel/103.png";